
import { Head, router } from '@inertiajs/react';
import React, { useState } from 'react';
import { DataTable } from "@/components/data-table"
import { Progress } from "@/components/ui/progress";
import FileDetailSidebar from "@/components/FileDetailSidebar";

export default function Index({ files, bucket_storage, background_removal_usage, pagination, filters, sorting, available_tags }) {
  const [selectedFile, setSelectedFile] = useState(null);

  return (
    <div className="container mx-auto py-6">
      <Head title="Dashboard" />

      {/* Usage Statistics - Full width at the top */}
      <div className="mb-8 px-4">
        <h2 className="pl-4 text-2xl font-bold mb-4">Usage Statistics</h2>
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-4">
          {/* Storage Usage - Takes 2/3 width */}
          <div className="lg:col-span-2 bg-white p-4 rounded-lg shadow">
            <h3 className="text-lg font-semibold mb-2">Storage Usage</h3>
            <Progress value={bucket_storage.percentage} className="mb-2" />
            <p className="text-sm text-gray-600">
              {bucket_storage.used} used of {bucket_storage.limit}
            </p>
          </div>
          
          {/* Background Removal Usage - Takes 1/3 width */}
          <div className="lg:col-span-1 bg-white p-4 rounded-lg shadow">
            <h3 className="text-lg font-semibold mb-2">Background Removals</h3>
            <Progress value={background_removal_usage.percentage} className="mb-2" />
            <p className="text-sm text-gray-600">
              {background_removal_usage.used} used of {background_removal_usage.limit} this month
            </p>
            <p className="text-xs text-gray-500 mt-1">
              {background_removal_usage.remaining} remaining
            </p>
          </div>
        </div>
      </div>

      {/* Flex container for DataTable and Sidebar */}
      <div className="flex flex-col lg:flex-row gap-6">
        {/* DataTable Area */}
        <div className="flex-grow lg:w-2/3">
          <div className="bg-white rounded-lg shadow h-full">
            <DataTable 
              data={files} 
              onFileSelect={setSelectedFile} 
              selectedFileId={selectedFile?.id}
              onFileDelete={(deletedFileId) => {
                // Close the sidebar if the deleted file is currently being viewed
                if (selectedFile && selectedFile.id === deletedFileId) {
                  setSelectedFile(null);
                }
              }}
              pagination={pagination}
              filters={filters}
              sorting={sorting}
              availableTags={available_tags}
              onPaginationChange={(newPagination) => {
                router.reload({
                  data: {
                    ...filters,
                    sort_by: sorting?.column || '',
                    sort_dir: sorting?.direction || 'asc',
                    page: newPagination.pageIndex + 1,
                    per_page: newPagination.pageSize,
                  },
                  only: ['files', 'pagination'],
                  preserveScroll: true
                });
              }}
              onFiltersChange={(newFilters) => {
                router.reload({
                  data: {
                    ...newFilters,
                    sort_by: sorting?.column || '',
                    sort_dir: sorting?.direction || 'asc',
                    page: 1, // Reset to first page when filtering
                    per_page: pagination?.items || 20,
                  },
                  only: ['files', 'pagination', 'filters'],
                  preserveScroll: true
                });
              }}
              onSortingChange={(newSorting) => {
                router.reload({
                  data: {
                    ...filters,
                    sort_by: newSorting.column,
                    sort_dir: newSorting.direction,
                    page: 1, // Reset to first page when sorting
                    per_page: pagination?.items || 20,
                  },
                  only: ['files', 'pagination', 'sorting'],
                  preserveScroll: true
                });
              }}
            />
          </div>
        </div>

        {/* Sidebar Area - Conditionally Rendered */}
        {selectedFile && (
          <div className="lg:w-1/3 lg:pl-4 pr-4">
            <FileDetailSidebar file={selectedFile} onClose={() => setSelectedFile(null)} />
          </div>
        )}
      </div>
    </div>
  )
}
